import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2bbdb4a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "menu" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]

import { toRefs } from "vue";
import { useRoute } from "vue-router";
interface NavigationTabs {
  title: string;
  index: string | number;
  subs: any;
  perMiss: number;
  icon: string;
  iconSelect: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'MenuView',
  props: {
    menuList: null
  },
  setup(__props: any) {

const props = __props as {
  menuList: NavigationTabs[];
};

let route = useRoute();

// 此处应为props传递过来 并在layout页面中获取数据
const { menuList } = toRefs(props);

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_el_menu = _resolveComponent("el-menu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_menu, {
      "background-color": "rgb(59, 164, 255)",
      "text-color": "white",
      "default-active": 
        _unref(route).query.id ? _unref(route).path + '?id=' + _unref(route).query.id : _unref(route).path
      ,
      "active-text-color": "#20a0ff",
      router: ""
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(menuList), (one, index) => {
          return (_openBlock(), _createElementBlock("div", { key: index }, [
            (!one.subs)
              ? (_openBlock(), _createBlock(_component_el_menu_item, {
                  key: 0,
                  index: one.index
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createElementVNode("img", {
                          src: one.icon,
                          alt: ""
                        }, null, 8, _hoisted_2)
                      ]),
                      _: 2
                    }, 1024),
                    _createElementVNode("span", null, _toDisplayString(one.title), 1)
                  ]),
                  _: 2
                }, 1032, ["index"]))
              : (_openBlock(), _createBlock(_component_el_sub_menu, {
                  key: 1,
                  index: one.index
                }, {
                  title: _withCtx(() => [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createElementVNode("img", {
                          src: one.icon,
                          alt: ""
                        }, null, 8, _hoisted_3)
                      ]),
                      _: 2
                    }, 1024),
                    _createElementVNode("span", null, _toDisplayString(one.title), 1)
                  ]),
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(one.subs, (two) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: two.index
                      }, [
                        (!two.subs)
                          ? (_openBlock(), _createBlock(_component_el_menu_item, {
                              key: 0,
                              index: two.index
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", null, _toDisplayString(two.title), 1)
                              ]),
                              _: 2
                            }, 1032, ["index"]))
                          : (_openBlock(), _createBlock(_component_el_sub_menu, {
                              key: 1,
                              index: two.index
                            }, {
                              title: _withCtx(() => [
                                _createTextVNode(_toDisplayString(two.title), 1)
                              ]),
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(two.subs, (three, index) => {
                                  return (_openBlock(), _createBlock(_component_el_menu_item, {
                                    index: two.index + '?id=' + index,
                                    key: index
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("span", null, _toDisplayString(three.title), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["index"]))
                                }), 128))
                              ]),
                              _: 2
                            }, 1032, ["index"]))
                      ]))
                    }), 128))
                  ]),
                  _: 2
                }, 1032, ["index"]))
          ]))
        }), 128))
      ]),
      _: 1
    }, 8, ["default-active"])
  ]))
}
}

})